// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"2328":"admin","3319":"scheduled-events","6521":"edit-video","8524":"video-playback"}[chunkId] || chunkId) + ".css";
};